import { action, computed } from 'mobx';
import { Variables, AppManager } from 'core';

import { InitiativeApp, InitiativeModel } from 'apps/initiative/app';
import { InitiativeCheckQuery } from 'apps/initiative/gql';
import { routerStore } from 'core/routing';

export class RouterAppManager extends AppManager {
  static registryName = 'RouterAppManager';
  constructor(parent, init = {}) {
    super(parent, init);
    this.AppRef('initiative', InitiativeApp);
    this.checkQuery = new InitiativeCheckQuery(this, {
      queryKey: 'checkInitiative',
      onSysErr: this.onError,
      variables: new Variables({
        slug: () => routerStore.route.params.spacePath,
      }),
    });
    this.checkQuery.process(
      result => !!result && InitiativeModel.Load(result),
      this.UpdateInitiative,
    );
    this.checkQuery.query();
  }

  @action UpdateInitiative = initiative => {
    if (initiative) {
      this.initiative = initiative;
    }
  };

  @computed get isAllowed() {
    return this.initiative && this.initiative.canUpdate;
  }

  @computed get notFound() {
    return this.checkQuery.notFound;
  }

  @computed get loading() {
    return this.checkQuery.loading;
  }
}
